import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
  chipStyle:{
    // color: "#F4B40D",
    minWidth: 52,
    // border: "1px solid #F4B40D",
    margin: "0 10px 6px",
    height: 20,
    backgroundColor: "#fff",
    fontSize: 12,
    '& span':{
      textTransform: 'capitalize',
    },
  },
  btnGroup:{
    display: "flex",
    justifyContent: "flex-end",
    '&>button':{
      marginRight: '10px',
      maxWidth: 103,
      width: "100%",
      padding: "0 23",
    },
    '& .btn-text': {
      fontSize: '16px',
      fontWeight: 400,
      color: '#1d7dea',
      backgroundColor: 'transparent !important',
      background: 'transparent',
      maxWidth: '152px',
      padding: '7px 10px',
    },
    '& .btn-blue': {
      fontSize: '16px',
      fontWeight: 400,
      color: '#FFFFFF',
      backgroundColor: '#1d7dea',
      padding: '7px 11px',
      maxWidth: '150px',
    }
  },
  backArrow:{
    marginTop: '4px',
    '& img':{
      verticalAlign: "sub",
      marginRight:10,
      marginLeft:13,
    },
    '& svg':{
      marginRight: 10,
      width: 20,
    }
  },
  backArrowHeading:{
    fontSize: 24,
    lineHeight: '33px',
    color: '#333',
    wordBreak: 'break-word',
  },
  dflex: {
    display: 'flex',
  },
  liveColor:{
    color:'#67BF02 !important',
    borderColor:'#67BF02 !important'
  },
  draftColor:{
    color:'#F4B40D !important',
    borderColor:'#F4B40D !important'
  },
  publishColor:{
    color:'#1d7dea !important',
    borderColor:'#1d7dea !important'
  },
  pastColor:{
    color:'#D9505D !important',
    borderColor:'#D9505D !important'
  },
  transparentButton:{
    background: "#FFFFFF",
    border: "1px solid #DDDDDD",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
    color: '#666666'
  },
  disabledCTA: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  coursePlanRequestModal: {
    position: 'relative',
    maxHeight: '563px',
    minHeight: '563px',
    '&>div': {
      minHeight: '563px'
    },
    '&>div>div:first-child': {
      paddingTop: '0 !important',
      height: '502px',
      '&>div': {
        position: 'relative',
        padding: 0,
        '& .title': {
          fontSize: '20px',
          fontWeight: 600,
          lineHeight: '27px',
          color: '#333333',
          margin: '0',
          borderBottom: 'solid 1px #E4E4E4',
          padding: '16px 10px 10px',
          textAlign: 'center',
          position: 'sticky',
          top: 0,
          backgroundColor: '#ffffff',
          zIndex: 9,
          '& img': {
            position: 'absolute',
            right: '15px',
            top: '20px',
            cursor: 'pointer',
          }
        },
        '& .confirmationMessageBox': {
          padding: '20px 20px 0',
        },
        '& .confirmationMessage': {
          backgroundColor: 'rgba(29, 125, 234, 0.1)',
          borderRadius: '4px',
          padding: '15px',
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: '15px',
          '& img': {
            width: '28px',
            marginRight: '9px',
          },
          '& p': {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '138%',
            color: '#666666',
            marginBottom: '5px',
            marginTop: 0,
            '&:last-child': {
              marginBottom: 0,
            }
          },
        },
        '& .noteText': {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '171%',
          color: '#666666',
          margin: 0,
          '& strong': {
            fontWeight: 700,
          },
        },
        '& .coursePlanRequestTab': {
          padding: '15px 20px 23px',
          display: 'flex',
          alignItems: 'center',
          margin: 0,
          listStyle: 'none',
          position: 'sticky',
          top: '54px',
          backgroundColor: '#fff',
          zIndex: 9,
          '& li': {
            padding: '0 15px',
            cursor: 'pointer',
            '&:first-child': {
              paddingLeft: 0,
            }
          },
          '& li span': {
            fontSize: '14px',
            fontWeight: 400,
            color: '#666666',
            padding: '0 0 8px',
            position: 'relative',
            display: 'block',
            '&::after': {
              content: "''",
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              width: '100%',
              height: '4px',
              backgroundColor: 'transparent',
              borderRadius: '10px',
            }
          },
          '& li.active span': {
            fontWeight: 700,
            color: '#1D7DEA',
            '&::after': {
              backgroundColor: '#1D7DEA',
            }
          }
        },
        '& .coursePlanRequestContent': {
          display: 'none',
          padding: '0 20px',
          overflow: 'auto',
          
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#ccc',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#9b9b9b',
            outline: 'none',
            borderRadius: '10px',
          },
        },
         '& .active': { 
          display: 'block' 
        },
        '& .ps__rail-y': {
          display: 'none',
        },  
        '& .mainHeading': {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '22px',
          color: '#333333',
          margin: '0 0 15px',
          textTransform: 'capitalize',
          '& strong': {
            fontWeight: 600,
          },
        },
        '& .dateChangeList': {
          border: '1px solid #E6E6E6',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          '& ul': {
            padding: '0 20px',
            margin: 0,
            listStyle: 'none',
            '& li': {
              borderBottom: '1px solid rgba(153, 153, 153, 0.5)',
              padding: '15px 0',
              '&:last-child': {
                borderBottom: 'none',
              },
              '& .dateTitleRow': {
                marginBottom: '15px',
                display: 'flex',
                alignItems: 'center',
                '& img': {
                  width: '16px',
                  marginRight: '13px',
                },
                '& .titleSec': {
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '138%',
                  margin: 0,
                }
              },
              '& .subTitle': {
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '138%',
                color: '#333333',
                margin: '0 0 5px',
              },
              '& .dateTimeSection': {
                display: 'flex',
                alignItems: 'center',
                margin: '0 -7.5px 16px',
                '& .dateTimeSectionCol': {
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0 7.5px',
                  '& img': {
                    width: '16px',
                    marginRight: '10px',
                  },
                  '& p': {
                    fontSize: '16px',
                    fontWeight: 200,
                    lineHeight: '125%',
                    color: '#333333',
                    margin: 0,  
                  }
                }
              },
              '& .paraText': {
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '125%',
                color: '#999999',
                marginBottom: 0,
              }
            }
          }
        },
        '& .phaseBlockSection': {
          '& .phaseBlockCol': {
            marginBottom: '20px',
            '& .phaseInfoGroup': {
              marginBottom: '15px',
              '&>ul': {
                margin: '0 -20px 0',
              }
            },
            '& .phaseInfo': {
              backgroundColor: '#FAFAFA',
              padding: '5px 20px',
              display: 'flex',
              listStyle: 'none',
              margin: '0 -20px 15px',
              '& li': {
                fontSize: '12px',
                fontWeight: 400,
                color: '#666666',
                padding: '0 12px',
                position: 'relative',
                '&:empty': {
                  display: 'none',
                },
                '&.whiteSpaceNoWrap': {
                  whiteSpace: 'nowrap',
                },
                '&::before': {
                  content: "''",
                  width: '4px',
                  height: '4px',
                  borderRadius: '50%',
                  backgroundColor: '#D9D9D9',
                  margin: '0 10px',
                  display: 'block',
                  position: 'absolute',
                  left: '-11px',
                  top: '7px',
                },
                '&:first-child::before': {
                  display: 'none',
                },
                '&:first-child': {
                  paddingLeft: 0,
                },
                '&:last-child': {
                  paddingRight: 0,
                },
                '& strong': {
                  fontWeight: 600,
                }
              }
            },
            '& .phasePrevInfo': {
              backgroundColor: '#FAFAFA',
              padding: '5px 20px',
              display: 'flex',
              listStyle: 'none',
              margin: '0 -20px 15px',
              '& li': {
                fontSize: '12px',
                fontWeight: 400,
                color: '#999999',
                position: 'relative',
                padding: '0 12px',
                '&::after': {
                  content: "''",
                  width: '4px',
                  height: '4px',
                  margin: '0 10px',
                  borderRadius: '50%',
                  backgroundColor: '#D9D9D9',
                  top: '7px',
                  left: '-11px',
                  position: 'absolute',
                },
                '&:first-child': {
                  paddingLeft: 0,
                  '&::after': {
                    display: 'none',
                  }
                },
                '&:last-child': {
                  paddingRight: 0,
                },
                '& strong': {
                  fontWeight: 600,
                },
                '&.whiteSpaceNoWrap': {
                  whiteSpace: 'nowrap',
                },
                '&:empty': {
                  padding: 0,
                  '&::after': {
                    display: 'none',
                  }
                }
              }
            },
            '& .phaseList': {
              padding: '0',
              margin: '0',
              listStyle: 'none',
              '& li': {
                borderBottom: 'solid 1px rgba(153, 153, 153, 0.5)',
                paddingBottom: '10px',
                marginBottom: '10px',
                '&:last-child': {
                  borderBottom: 'none',
                  marginBottom: 0,
                  paddingBottom: 0,
                },
                '& .phaseTitle': {
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '22px',
                  color: '#333333',
                  margin: '0 0 4px',
                  display: 'flex',
                  '& p': {
                    margin: '0 0 0 5px',
                  }
                },
                '& .datePhaseLabel': {
                  marginBottom: '5px',
                },
                '& .arrowIcon': {
                  margin: '0 5px',
                },
                '& .phaseSubTitle': {
                  fontSize: '14px',
                  lineHeight: '19px',
                  fontWeight: 400,
                  color: '#333333',
                  margin: '10px 0 8px',
                },
                '& .otherInfo': {
                  fontSize: '12px',
                  fontWeight: 400,
                  color: '#999999',
                  lineHeight: '15px',
                  margin: '12px 0 0',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  width: '100%',
                  whiteSpace: 'nowrap',
                },
              },
              '& .paraSection': {
                display: 'flex',
                '& .iconCol': {
                  width: '24px',
                  minWidth: '24px',
                  height: '24px',
                  marginRight: '5px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '& img': {
                    maxWidth: '100%',
                    maxHeight: '100%',
                  }
                },
                '& p': {
                  fontSize: '16px',
                  fontWeight: 200,
                  lineHeight: '20px',
                  color: '#333333',
                  margin: '3px 0 10px',
                  '&:last-child': {
                    marginBottom: 0,
                  }
                },
              },
            }
          }
        }
      },
      '&:last-child': {
        padding: '20px 20px !important',
        border: 0,
      }
    },
    '&>div>div:nth-child(2)': {
      borderBottom: 'none !important',
    },
    '& .btnBlue': {
      padding: '0 20px',
      minWidth: '120px',
      fontSize: '16px',
      fontWeight: 400,
    },
},
});


export { styles}

